import { render, staticRenderFns } from "./AcessoLoginDepartamento.vue?vue&type=template&id=f9ac0552&scoped=true&lang=pug&"
import script from "./AcessoLoginDepartamento.vue?vue&type=script&lang=js&"
export * from "./AcessoLoginDepartamento.vue?vue&type=script&lang=js&"
import style0 from "./AcessoLoginDepartamento.vue?vue&type=style&index=0&id=f9ac0552&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ac0552",
  null
  
)

export default component.exports